var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1B4ADD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4424 13.4431L12.5003 15.9652C12.4725 16.0352 12.4725 16.1129 12.5003 16.1828L14.1181 20.5239L15.9902 19.4668L13.7445 13.4431C13.6928 13.3032 13.494 13.3032 13.4424 13.4431Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3262 9.20013C15.2746 9.06024 15.0759 9.06024 15.0242 9.20013L14.0822 11.7223C14.0543 11.7923 14.0543 11.87 14.0822 11.94L16.7333 19.048L18.6055 17.9909L15.3262 9.20013Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 3.67754C12.0471 3.67754 12.0908 3.6892 12.1345 3.71252L19.2732 7.74259C19.3567 7.78922 19.4084 7.87472 19.4084 7.96799V16.0281C19.4084 16.1214 19.3567 16.2069 19.2732 16.2535L12.1345 20.2875C12.0948 20.3108 12.0471 20.3225 11.9994 20.3225C11.9517 20.3225 11.908 20.3108 11.8643 20.2875L4.72951 16.2574C4.64605 16.2108 4.59437 16.1253 4.59437 16.032V7.96799C4.59437 7.87472 4.64605 7.78922 4.72951 7.74259L11.8682 3.71252C11.908 3.6892 11.9557 3.67754 11.9994 3.67754ZM11.9994 2.5C11.745 2.5 11.4906 2.56607 11.264 2.69431L4.12535 6.72438C3.67222 6.98088 3.39001 7.455 3.39001 7.96799V16.0281C3.39001 16.5411 3.67222 17.0191 4.12535 17.2756L11.264 21.3057C11.4906 21.4339 11.745 21.5 11.9994 21.5C12.2538 21.5 12.5082 21.4339 12.7347 21.3057L19.8734 17.2756C20.3305 17.0191 20.6088 16.545 20.6088 16.0281V7.96799C20.6088 7.455 20.3266 6.97699 19.8734 6.72049L12.7387 2.69431C12.5082 2.56607 12.2538 2.5 11.9994 2.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28186 19.0554L7.9377 17.2988L9.25733 18.3714L8.02514 19.4751L7.28186 19.0554Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3989 7.39209H9.59043C9.45529 7.39209 9.33203 7.4737 9.28832 7.59806L5.40894 17.9977L7.28106 19.0548L11.554 7.60195C11.5897 7.50091 11.5142 7.39209 11.3989 7.39209Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5665 7.39209H12.758C12.6229 7.39209 12.4996 7.4737 12.4559 7.59806L8.02405 19.4745L9.89615 20.5316L14.7176 7.60583C14.7573 7.50091 14.6779 7.39209 14.5665 7.39209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.10a31aead610c75207c94f9394655295.svg";
export { ForwardRef as ReactComponent };